import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


const HeaderTop = () => {
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);

  // const scrollToSection = (id) => {
  //   const el = document.getElementById(id);
  //   if (el) {
  //     el.scrollIntoView({ behavior: "smooth" });
  //     setMenuOpen(false); // Auto-close on click
  //   }
  // };
  const scrollToSection = (id) => {
  navigate(`#${id}`, { replace: false });
    const section = document.getElementById(id);
    if (section) {
      const offsetTop = section.offsetTop - 80; // Leave 100px space at the topMore actions
    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
    setMenuOpen(false); // Close mobile menu
  }
  };


  return (
    <>
      <header className="custom-header d-flex align-items-center justify-content-md-around px-3">
        {/* Mobile toggle button */}
        <div className="d-md-none mobile-toggle-wrapper">
          <button className={`hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Left + Nav */}
        <div className="d-flex align-items-center gap-3">
          <img src="https://www.gphomes.in/static/media/gp-logo.110bc015e25257973a49.png" alt="KG Logo" className="left-logo d-md-none" />
          <nav className="nav-links d-none d-md-flex gap-4">
            <a className="fs-5" onClick={() => scrollToSection("home")}>Home</a>
            <a className="fs-5" onClick={() => scrollToSection("About-Us")}>About</a>
            {/* <a className="fs-5" onClick={() => scrollToSection("Configuration")}>Plot Details</a> */}
            <a className="fs-5" onClick={() => scrollToSection("Overview")}>Overview</a>
            
          </nav>
        </div>

        {/* Center Logo */}
        <div className="center-logo-container d-none d-md-block">
          <img src="https://www.gphomes.in/static/media/gp-logo.110bc015e25257973a49.png" alt="Kingdom of Joy" className="center-logo py-2" />
        </div>

        {/* Right Nav + Call */}
        <div className="d-flex align-items-center gap-4">
          <nav className="nav-links d-none d-md-flex gap-4">
            
            <a className="fs-5" onClick={() => scrollToSection("Amenities")}>Amenities</a>
            <a className="fs-5" onClick={() => scrollToSection("Contact")}>Contact</a>
          </nav>
          <a href="tel:+916384003003" className="call-button d-none d-md-flex">
            <FaPhoneAlt /> 6384003003
          </a>
        </div>
      </header>

      {/* Mobile Slide Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <nav className="mobile-nav d-flex flex-column gap-4 p-4">
          <a onClick={() => scrollToSection("home")}>Home</a>
          <a onClick={() => scrollToSection("About-Us")}>About</a>
          {/* <a onClick={() => scrollToSection("Configuration")}>Plot Details</a> */}
          <a onClick={() => scrollToSection("Overview")}>Overview</a>
          <a onClick={() => scrollToSection("Amenities")}>Amenities</a>
          <a onClick={() => scrollToSection("Contact")}>Contact</a>
          <a href="tel:+916384003003" className="call-button mt-3 text-dark">
            <FaPhoneAlt /> 6384003003
          </a>
        </nav>
      </div>
    </>
  );
};

export default HeaderTop;
